import { loadMinicart, openMinicart } from '../components/minicart';

const getSelectedVariant = (form, product) => {
  if (!form || !product) return null;
  const idField = form.querySelector('input[name="id"]');
  const submit = form.querySelector('[type="submit"]');
  if (!idField || !submit) return;

  const selectedValues = [];
  form
    .querySelectorAll('[product-option] input[type="radio"]:checked')
    .forEach((option) => {
      selectedValues.push({
        value: option.value,
        index: option.name,
      });
    });

  const variant = product.variants.find((variant) => {
    return selectedValues.every((value) => {
      return variant[value.index] == value.value;
    });
  });

  const context = $('#' + product.id + '');
  const currentAvailable = $(
    '.product-tile__hover--color__dot[selected]',
    context,
  ).attr('data-available');
  const currentMultiplier = $('input[name="multiplier"]', context);
  let selectedMultiplier = 1;
  const defaultMultiplier = context.attr('data-default-multiplier')
    ? context
    : context.find('[data-default-multiplier]');
  if (defaultMultiplier.length) {
    const defaultMultiplierValue = parseInt(
      defaultMultiplier.attr('data-default-multiplier'),
    );
    if (Number.isInteger(defaultMultiplierValue)) {
      selectedMultiplier = defaultMultiplierValue;
    }
  }

  if (variant) {
    idField.value = variant.id;
    if (
      (variant.available && currentAvailable == 'true') ||
      (variant.available && product.variants.length >= 1)
    ) {
      submit.disabled = false;
    } else {
      submit.disabled = true;
    }
  } else {
    idField.value = '';
    submit.disabled = true;
  }

  if ($('.product-tile__hover--color__dot[selected]', context).length) {
    selectedMultiplier = $(
      '.product-tile__hover--color__dot[selected]',
      context,
    ).attr('data-multiplier');
  }

  if (selectedMultiplier && currentMultiplier) {
    currentMultiplier.val(selectedMultiplier);
  }

  if (!variant.compare_at_price || variant.compare_at_price <= variant.price) {
    const formattedPrice = theme.Currency.formatMoney(
      variant.price * selectedMultiplier,
    ).replace('.', ',');
    $('.product-tile__meta__price__label', context).text(formattedPrice);
    $('.product-tile__meta__price__sale--price', context).text('');
    $('.product-tile__meta__price', context).removeClass('strike-price');
  } else {
    const formattedSalePrice = theme.Currency.formatMoney(
      variant.price * selectedMultiplier,
    ).replace('.', ',');
    const formattedComparePrice = theme.Currency.formatMoney(
      variant.compare_at_price * selectedMultiplier,
    ).replace('.', ',');
    $('.product-tile__meta__price__sale--price', context).text(
      formattedSalePrice,
    );
    $('.product-tile__meta__price__label', context).text(formattedComparePrice);
    $('.product-tile__meta__price', context).addClass('strike-price');
  }

  return variant;
};

if (!window.dAgency) window.dAgency = {};
window.dAgency.initProductTile = (tile) => {
  if (!tile) return;

  const tileHover = tile.querySelector('.product-tile__hover');
  if (tileHover) {
    const productForm = tileHover.querySelector(
      '.product-tile__hover--quick-buy__form',
    );

    const productFormButton = tileHover.querySelector(
      '.product-tile__hover--quick-buy--button',
    );

    if (!productForm) return;
    const productJsonScript = productForm.querySelector('[product-json]');
    const idField = productForm.querySelector('input[name="id"]');
    if (!idField || !productJsonScript || !productJsonScript.innerHTML.trim())
      return;

    const product = JSON.parse(productJsonScript.innerHTML.trim());
    getSelectedVariant(productForm, product);

    productForm.addEventListener('change', () => {
      getSelectedVariant(productForm, product);
    });

    productForm.addEventListener('submit', (e) => {
      e.preventDefault();
      if (
        typeof ShopifyAPI !== 'undefined' &&
        typeof ShopifyAPI.addItemFromForm !== 'undefined'
      ) {
        ShopifyAPI.addItemFromForm(productForm, async () => {
          await loadMinicart();
          openMinicart();
        });
      } else {
        productForm.submit();
      }
    });

    if (productFormButton) {
      productFormButton.addEventListener('mouseenter', () => {
        productFormButton.classList.add('active');
      });

      productFormButton.addEventListener('mouseleave', () => {
        productFormButton.classList.remove('active');
      });
    }
  }

  // MANAGE PRODUCT VARIANTS SWATCHES

  const productVariants = tile.querySelector('.product-tile__variants');
  const productImages = tile.querySelector('.product-tile__images');

  if (productVariants) {
    const dots = $(tile).find('.product-tile__hover--color__dot');

    const productLink = $(tile).find(
      '.product-tile__meta__title__product-title > a',
    )[0];
    dots.each(function () {
      $(this).on('click', function () {
        const variantSku = $(this).data('variant-sku');
        const variantColor = $(this).data('color-name');
        const variantUrl = $(this).data('variant-url');
        const activeImages = $(productImages).find(
          '.image-wrapper[data-variant-sku="' + variantSku + '"',
        );

        $(productLink).attr('href', variantUrl);
        $(productImages).attr('data-link-proxy', variantUrl);
        $(productImages).find('.image-wrapper').addClass('hidden');

        if (activeImages.length > 1) {
          $(productImages).attr('data-img-change', true);
        } else {
          $(productImages).attr('data-img-change', false);
        }

        activeImages.each(function () {
          $(this).removeClass('hidden');
        });
        $(this).siblings().attr('selected', false);
        $(this).attr('selected', true);

        $(tile)
          .find(
            '[product-option] input[type="radio"][value="' +
              variantColor +
              '"]',
          )
          .click();
      });
    });
  }
};

if (document.readyState != 'loading') {
  [].forEach.call(
    document.querySelectorAll('.product-tile__container'),
    (tile) => {
      window.dAgency.initProductTile(tile);
    },
  );
} else {
  document.addEventListener('DOMContentLoaded', () => {
    [].forEach.call(
      document.querySelectorAll('.product-tile__container'),
      (tile) => {
        window.dAgency.initProductTile(tile);
      },
    );
  });
}
